<template>
    <tr>
        <td class="name">{{person.desc}}</td>
        <td class="id">{{id}}</td>
        <td :class="{'changed': changed.admin_payments}" @click="changeValue('admin_payments')">{{person.permissions.admin_payments }}</td>
        <td class="openInfo" :class="{ opened: openFraud }" @click="openFraudInfo">
            Fraud
            <div>
                <img :class="{ rotate: openFraud }" src="../../assets/images/down-arrow.svg" alt="open">
            </div>
        </td>
<!--        <td :class="{'changed': changed.fraud_delete_base}" @click="changeValue('fraud_delete_base')">{{person.fraud_delete_base }}</td>-->
<!--        <td :class="{'changed': changed.fraud_delete_full}" @click="changeValue('fraud_delete_full')">{{person.fraud_delete_full }}</td>-->
<!--        <td :class="{'changed': changed.fraud_full_read}" @click="changeValue('fraud_full_read')">{{person.fraud_full_read }}</td>-->
<!--        <td :class="{'changed': changed.fraud_support_read}" @click="changeValue('fraud_support_read')">{{person.fraud_support_read}}</td>-->
<!--        <td :class="{'changed': changed.fraud_write_base}" @click="changeValue('fraud_write_base')">{{person.fraud_write_base}}</td>-->
<!--        <td :class="{'changed': changed.fraud_write_full}" @click="changeValue('fraud_write_full')">{{person.fraud_write_full}}</td>-->
        <td :class="{'changed': changed.manage_user_items}" @click="changeValue('manage_user_items')">{{person.permissions.manage_user_items }}</td>
        <td :class="{'changed': changed.moderator_payments}" @click="changeValue('moderator_payments')">{{person.permissions.moderator_payments }}</td>
        <td :class="{'changed': changed.read_user_items}" @click="changeValue('read_user_items')">{{person.permissions.read_user_items}}</td>
        <td :class="{'changed': changed.rns}" @click="changeValue('rns')">{{person.permissions.rns}}</td>
        <td class="super">{{person.permissions.super}}</td>
        <td :class="{'changed': changed.support_payments}" @click="changeValue('support_payments')">{{person.permissions.support_payments}}</td>
        <td class="openInfo" :class="{ opened: openAntiScam }" @click="openAntiScamInfo">
            Anti-scam
            <div>
                <img :class="{ rotate: openAntiScam }" src="../../assets/images/down-arrow.svg" alt="open">
            </div>
        </td>
        <td class="openInfo" :class="{ opened: openAccounting }" @click="openAccountingInfo">
            More
            <div>
                <img :class="{ rotate: openAccounting }" src="../../assets/images/down-arrow.svg" alt="open">
            </div>
        </td>
        <td :class="{'changed': changed.mm_beta_test_admin}" @click="changeValue('mm_beta_test_admin')">
            {{person.permissions.mm_beta_test_admin}}
        </td>
      <td :class="{'changed': changed.goods_admin}" @click="changeValue('goods_admin')">
        {{person.permissions.goods_admin}}
      </td>
      <td :class="{'changed': changed.balances}" @click="changeValue('balances')">
        {{person.permissions.balances}}
      </td>
      <td :class="{'changed': changed.manage_reviews}" @click="changeValue('manage_reviews')">
        {{person.permissions.manage_reviews}}
      </td>
        <div class="moreInfo" :class="{moreInfoOpen: openFraud}">
            <div class="moreInfo__param">
                Fraud Delete Base:
                <span :class="{'changed': changed.fraud_delete_base}" @click="changeValue('fraud_delete_base')">{{person.permissions.fraud_delete_base}}</span>
            </div>
            <div class="moreInfo__param">
                Fraud Delete Full:
                <span :class="{'changed': changed.fraud_delete_full}" @click="changeValue('fraud_delete_full')">{{person.permissions.fraud_delete_full}}</span>
            </div>
            <div class="moreInfo__param">
                Fraud Full Read:
                <span :class="{'changed': changed.fraud_full_read}" @click="changeValue('fraud_full_read')">{{person.permissions.fraud_full_read}}</span>
            </div>
            <div class="moreInfo__param">
                Fraud Support Read:
                <span :class="{'changed': changed.fraud_support_read}" @click="changeValue('fraud_support_read')">{{person.permissions.fraud_support_read}}</span>
            </div>
            <div class="moreInfo__param">
                Fraud Write Base:
                <span :class="{'changed': changed.fraud_write_base}" @click="changeValue('fraud_write_base')">{{person.permissions.fraud_write_base}}</span>
            </div>
            <div class="moreInfo__param">
                Fraud Write Full:
                <span :class="{'changed': changed.fraud_write_full}" @click="changeValue('fraud_write_full')">{{person.permissions.fraud_write_full}}</span>
            </div>
        </div>
        <div class="moreInfo antiScamInfoRights" :class="{moreInfoOpen: openAntiScam}">
            <div class="moreInfo__param">
                Bot check:
                <span :class="{'changed': changed.bot_check}" @click="changeValue('bot_check')">{{person.permissions.bot_check}}</span>
            </div>
            <div class="moreInfo__param">
                Anti scam check:
                <span :class="{'changed': changed.asc_stat}" @click="changeValue('asc_stat')">{{person.permissions.asc_stat}}</span>
            </div>
            <div class="moreInfo__param">
                Anti scam session:
                <span :class="{'changed': changed.ass_stat}" @click="changeValue('ass_stat')">{{person.permissions.ass_stat}}</span>
            </div>
        </div>
        <div class="moreInfo antiScamInfoRights" :class="{moreInfoOpen: openAccounting}">
            <div class="moreInfo__param">
                Acc once payments:
                <span :class="{'changed': changed.acc_once_payments}" @click="changeValue('acc_once_payments')">{{person.permissions.acc_once_payments}}</span>
            </div>
            <div class="moreInfo__param">
                Acc multi payments:
                <span :class="{'changed': changed.acc_multi_payments}" @click="changeValue('acc_multi_payments')">{{person.permissions.acc_multi_payments}}</span>
            </div>
        </div>
    </tr>
</template>

<script>
export default {
    name: "TableRowRights",
    props: ['person', 'id', 'requestBody'],
    data () {
        return {
            changed: {
                admin_payments: false,
                fraud_delete_base: false,
                fraud_delete_full: false,
                fraud_full_read: false,
                fraud_support_read: false,
                fraud_write_base: false,
                fraud_write_full: false,
                manage_user_items: false,
                moderator_payments: false,
                read_user_items: false,
                rns: false,
                support_payments: false,
                bot_check: false,
                asc_stat: false,
                ass_stat: false,
                acc_once_payments: false,
                acc_multi_payments: false,
                mm_beta_test_admin: false,
                goods_admin: false,
                balances: false,
                manage_reviews: false,
                superpasses: false
            },
            openFraud: false,
            openAntiScam: false,
            openAccounting: false
        }
    },
    methods: {
        checkUserId () {
          if (this.requestBody[this.id]) {
              return
          }  else {
              this.requestBody[this.id] = {}
          }
        },
        changeValue (value) {
            this.person.permissions[value] = !this.person.permissions[value]
            this.changed[value] = !this.changed[value]
            this.checkUserId()
            this.requestBody[this.id][value] = this.person.permissions[value]
        },
        openFraudInfo () {
            this.openFraud = !this.openFraud
        },
        openAntiScamInfo () {
            this.openAntiScam = !this.openAntiScam
        },
        openAccountingInfo () {
            this.openAccounting = !this.openAccounting
        }
    }
}
</script>
